/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

const pathname = '/standard-processes';

export const StandardProcessApi = {
  find: async (option: FindStandardProcessOptions) => {
    let url = `${pathname}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindStandardProcessOptions {
  page: number;
  take: number;
  name?: string;
  standardProcessTypeID?: string;
  standardObjectTypeID?: string;
}
